const useStyles = {
  menuList: {
    minWidth: '200px',
  },
}

export default useStyles
